module.exports = __webpack_public_path__ + "media/images/webpage/pages/about/sp-trust-d7aff30caf74dcd86205f875e58c5cf4.webp";